.button {
  display: inline-flex;
  border-radius: var(--dds-border-radius-button);
  color: var(--dds-color-icon-default);

  &:hover:not(:disabled) {
    background-color: var(--dds-color-surface-hover-default);
    color: var(--dds-color-icon-action-hover);
  }
  &:not(:focus-visible) {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
  }

  @media (prefers-reduced-motion: no-preference) {
    transition:
      background-color var(--dds-motion-micro-state),
      color var(--dds-motion-micro-state),
      var(--dds-focus-transition);
  }
}
